import { ADD_TIMESHEET, ADD_TIMESHEET_FAILED, ADD_TIMESHEET_SUCCESS, TIMESHEET, TIMESHEET_FAILED, TIMESHEET_SUCCESS, UPDATE_TIMESHEET, UPDATE_TIMESHEET_FAILED, UPDATE_TIMESHEET_SUCCESS } from "./actionTypes"

let initialState = {
    timesheet: [],
    addTimesheet: "",
    updateTimesheet: "",
    loading: false,
    success: false,
    error: ''
}

export const timesheetReducer = (state = initialState, action) => {
    switch (action.type) {

        case TIMESHEET: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case TIMESHEET_SUCCESS: return {
            ...state,
            timesheet: action.payload,
            loading: false,
            success: true
        }
        case TIMESHEET_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_TIMESHEET: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_TIMESHEET_SUCCESS: return {
            ...state,
            addTimesheet: action.payload,
            timesheet: [...state.timesheet, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_TIMESHEET_FAILED: return {
            ...state,
            addTimesheet: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_TIMESHEET: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_TIMESHEET_SUCCESS: return {
            ...state,
            updateTimesheet: action.payload,
            timesheet: state.timesheet.map((item) => item.id === action.payload.id ? action.payload : item),
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_TIMESHEET_FAILED: return {
            ...state,
            updateTimesheet: [],
            loading: false,
            success: false,
            error: action.payload
        }


        default: return state
    }
}